<template>
    <div class="client-data-consent-page">
        <app-sub-title text="Tratamiento de datos" />
        <p class="text-muted">
            Puede registrar la política de dos formas: subiendo un archivo o indicando la URL de una página externa.
        </p>

        <div v-if="url" class="mb-3 p-2 border rounded bg-light">
            <strong>Valor actual:</strong>
            <a :href="url" target="_blank" rel="noopener noreferrer">{{ url }}</a>
        </div>

        <b-card class="mb-3" header="1. Subir archivo">
            <b-form-group
                label="Archivo"
                description="PDF, Word o imagen (máx. 15 MB)."
            >
                <b-form-file
                    v-model="file"
                    placeholder="Seleccione un archivo..."
                    drop-placeholder="Arrastre aquí..."
                    accept=".pdf,.doc,.docx,image/*"
                />
            </b-form-group>
            <b-button
                variant="primary"
                :disabled="uploading || !file"
                @click="uploadFile"
            >
                <i class="fa fa-cloud-upload" />
                {{ uploading ? 'Subiendo…' : 'Guardar archivo' }}
            </b-button>
        </b-card>

        <b-card header="2. URL de página externa">
            <b-form-group
                label="URL"
                description="Si la política está publicada en otro sitio, pegue el enlace completo (https://…)."
            >
                <b-form-input v-model="externalUrl" type="url" placeholder="https://..." />
            </b-form-group>
            <b-button variant="outline-primary" :disabled="saving" @click="saveExternalUrl">
                <i class="fa fa-save" />
                {{ saving ? 'Guardando…' : 'Guardar URL' }}
            </b-button>
        </b-card>
    </div>
</template>

<script>
import base2 from '../../../repositories/base2.repository'
import { axios } from '../../../repositories/axios'
import { _url } from '../../../utils/http.util'
import SubTitle from '../../UI/Layout/SubTitle.vue'

export default {
    components: {
        appSubTitle: SubTitle,
    },
    data() {
        return {
            url: '',
            externalUrl: '',
            file: null,
            saving: false,
            uploading: false,
        }
    },
    async mounted() {
        await this.load()
    },
    methods: {
        async load() {
            try {
                const { data } = await base2.get('clients/data-consent')
                const v = (data && data.data_consent) || ''
                this.url = v
                this.externalUrl = v
            } catch (e) {
                toastr.error('No se pudo cargar la información')
            }
        },
        async uploadFile() {
            if (!this.file) {
                toastr.warning('Seleccione un archivo')
                return
            }
            this.uploading = true
            try {
                const fd = new FormData()
                fd.append('file', this.file)
                const tokenEl = document.querySelector('meta[name="csrf-token"]')
                const { data } = await axios.post(
                    _url('clients/data-consent/upload'),
                    fd,
                    {
                        headers:
                            tokenEl && tokenEl.content
                                ? { 'X-CSRF-TOKEN': tokenEl.content }
                                : {},
                    }
                )
                if (data && data.status) {
                    toastr.success(data.msg || 'Archivo guardado')
                    this.url = data.data_consent || ''
                    this.externalUrl = this.url
                    this.file = null
                } else {
                    toastr.error((data && data.msg) || 'Error al subir')
                }
            } catch (e) {
                const msg =
                    e.response &&
                    e.response.data &&
                    (e.response.data.msg || e.response.data.message)
                toastr.error(msg || 'No se pudo subir el archivo')
            } finally {
                this.uploading = false
            }
        },
        async saveExternalUrl() {
            const trimmed = (this.externalUrl || '').trim()
            if (!trimmed) {
                toastr.warning('Escriba una URL o use la subida de archivo')
                return
            }
            this.saving = true
            try {
                const { data } = await base2.put('clients/data-consent', {
                    data_consent: trimmed,
                })
                if (data && data.status) {
                    toastr.success(data.msg || 'Guardado')
                    this.url = data.data_consent || trimmed
                }
            } catch (e) {
                toastr.error('No se pudo guardar')
            } finally {
                this.saving = false
            }
        },
    },
}
</script>
